"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { recordVisitedPath } from "@/lib/compare/compareSource";

/**
 * Records the path the visitor is on so the compare tool can tell where they arrived
 * from. App Router navigations are client-side, so `document.referrer` never updates
 * and cannot answer that on its own.
 *
 * Renders nothing and holds no state — mounted once from the root layout, alongside
 * MicrosoftClarity, so it does not push a client boundary down into the page tree.
 */
export default function RouteHistory() {
  const pathname = usePathname();

  useEffect(() => {
    recordVisitedPath(pathname);
  }, [pathname]);

  return null;
}
